import { AudienceSegmentRender, SegmentData } from '../components';
import { createWorkflowUpdatesChangeExtension } from './workflow-updates-change';

const describeSegmentChanges = (change: {
  oldValue?: unknown;
  newValue?: unknown;
}): string[] => {
  const oldValue = change.oldValue as SegmentData | null;
  const newValue = change.newValue as SegmentData | null;
  const changes: string[] = [];

  if (
    oldValue?.allocation?.proportion?.value !==
    newValue?.allocation?.proportion?.value
  ) {
    changes.push('allocation');
  }

  if (
    JSON.stringify(oldValue?.targeting) !== JSON.stringify(newValue?.targeting)
  ) {
    changes.push('inclusion criteria');
  }

  return changes;
};

export const AUDIENCE_SEGMENT_CHANGE_EXTENSION =
  createWorkflowUpdatesChangeExtension({
    id: 'audience-segment-change',
    priority: 1,
    predicate: ({ change }) =>
      change.fieldPath === '/module_data/flags/segment',
    title: change => {
      const changes = describeSegmentChanges(change);

      if (changes.length === 1) {
        return `Updated ${changes[0]}`;
      }

      return 'Updated audience targeting';
    },
    render: AudienceSegmentRender,
  });
